

























































import Vue from 'vue'

// import moment from 'moment'
import TblAlarm from '@/components/tbl-alarm-history/index.vue'
import { table2CSV } from '@/utils/csv'
// import { Datepicker } from '@livelybone/vue-datepicker'

import { Alarm, AlarmQuery, FindAlarms, AckAll } from '@/api/cems'
import moment from 'moment'

// const timeFormat = 'YYYY-MM-DD HH:mm:ss'

export default Vue.extend({
  name: 'PageAlarm',
  components: {
    // [DateRangePicker.name]: DateRangePicker,
    TblAlarm,
  },
  data() {
    return {
      datePicker: {
        timeStr: ['hour', 'min', 'sec'],
        dayStr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        popperProps: {
          popperOptions: {
            modifiers: {
              preventOverflow: {
                padding: 20,
              },
            },
          },
        },
      },
      query: {
        timeRange: [],
        status: [] as string[],
        message: '',
      },
      alarms: [] as Alarm[],
    }
  },
  methods: {
    async findAlarm() {
      const q: AlarmQuery = {
        Message: this.query.message,
        StartTime: 0,
        EndTime: 0,
        Status: '',
      }
      if (this.query.timeRange.length == 2) {
        q.StartTime = moment(this.query.timeRange[0]).valueOf()
        q.EndTime = moment(this.query.timeRange[1]).valueOf()
      }

      q.Status = this.query.status.join('')

      const result = await FindAlarms(q)
      this.alarms = result
    },

    async ackAll() {
      await AckAll()
      await this.findAlarm()
    },

    export2csv() {
      table2CSV('tabel-alarm', 'Alarm history.csv')
    },
  },

  created() {
    this.findAlarm()
  },
})
